import type { Lang } from './dict';
import { canonicalFor, seoForPath, OG_IMAGE, type PageSeo } from './seoMeta';

function setMeta(key: string, content: string, attribute = 'name') {
  let element = document.head.querySelector<HTMLMetaElement>(`meta[${attribute}="${key}"]`);
  if (!element) {
    element = document.createElement('meta');
    element.setAttribute(attribute, key);
    document.head.appendChild(element);
  }
  element.content = content;
}
export function applyPageSeo(meta: PageSeo, preserveIdentity = false) {
  if (!preserveIdentity) {
    document.title = meta.title;
    document.documentElement.lang = meta.htmlLang;
  }
  document.head.querySelectorAll('link[rel="canonical"], link[rel="alternate"][hreflang], script[type="application/ld+json"], meta[property="og:locale:alternate"]').forEach(element => element.remove());
  const canonical = document.createElement('link');
  canonical.rel = 'canonical'; canonical.href = meta.canonical; document.head.appendChild(canonical);
  for (const alternate of meta.alternates ?? []) {
    const link = document.createElement('link');
    link.rel = 'alternate'; link.hreflang = alternate.lang; link.href = alternate.href; document.head.appendChild(link);
  }
  setMeta('description', meta.description);
  setMeta('robots', meta.robots ?? 'index, follow');
  setMeta('og:title', meta.title, 'property');
  setMeta('og:description', meta.description, 'property');
  setMeta('og:url', meta.canonical, 'property');
  setMeta('og:locale', meta.ogLocale, 'property');
  setMeta('og:type', meta.jsonLd?.['@type'] === 'Article' ? 'article' : 'website', 'property');
  setMeta('og:image:alt', meta.imageAlt, 'property');
  setMeta('og:image', meta.image ?? OG_IMAGE, 'property');
  setMeta('twitter:image', meta.image ?? OG_IMAGE);
  setMeta('twitter:title', meta.title);
  setMeta('twitter:description', meta.description);
  if (meta.jsonLd) {
    const script = document.createElement('script');
    script.type = 'application/ld+json'; script.textContent = JSON.stringify(meta.jsonLd); document.head.appendChild(script);
  }
}
export function applySeoTagsForPath(pathname: string) {
  const meta = seoForPath(pathname);
  applyPageSeo(meta, meta.robots === 'noindex, nofollow');
}
export function applySeoTags(lang: Lang) { applySeoTagsForPath(new URL(canonicalFor(lang)).pathname); }
